<script setup lang="ts">
/**
 * Confirmation-dialog host. Render once near the app root (or per page) so
 * `useConfirmDialog().require(...)` calls have a portal target.
 *
 * Pure pass-through over PrimeVue ConfirmDialog — keeps the full $attrs +
 * slot surface so callers can pass `group`, `style`, custom message slots,
 * etc.
 */
import PrimeConfirmDialog from 'primevue/confirmdialog'

defineOptions({ inheritAttrs: false })
</script>

<template>
  <PrimeConfirmDialog v-bind="$attrs">
    <template v-if="$slots.message" #message="slotProps">
      <slot name="message" v-bind="slotProps" />
    </template>
    <template v-if="$slots.container" #container="slotProps">
      <slot name="container" v-bind="slotProps" />
    </template>
    <template v-if="$slots.icon" #icon>
      <slot name="icon" />
    </template>
  </PrimeConfirmDialog>
</template>
